import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ClipboardListIcon, MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { DiscoveryForm } from '../components/DiscoveryForm';
export function ContactPage() {
  return <main data-id="element-165" data-mp="sscbz571lwrc">
      <section className="bg-[#f8f7f3] px-5 py-14 sm:px-8 sm:py-20 lg:px-10 lg:py-24" aria-labelledby="contact-page-heading" data-id="element-166" data-mp="sslw4c5ep9p4">
        <div className="mx-auto max-w-7xl" data-id="element-167" data-mp="10ep83fpdbnx">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-stone-600 transition-colors hover:text-[#172820] focus:outline-none focus:ring-2 focus:ring-[#286151] focus:ring-offset-2" data-id="element-168" data-mp="11g1uccda67r">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-169" data-mp="ezw9c5i200qy" /> Back to
            home
          </Link>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="mt-14 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end" data-id="element-170" data-mp="1le5av3p7wr8u">
            <div data-id="element-171" data-mp="hzqgwciz1djz">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#286151]" data-id="element-172" data-mp="hz78pnj4i3j5">
                Project enquiry
              </p>
              <h1 id="contact-page-heading" className="mt-5 max-w-3xl text-5xl font-semibold leading-[0.98] tracking-[-0.045em] text-[#172820] sm:text-6xl" style={{
              fontFamily: 'var(--font-display)'
            }} data-id="element-173" data-mp="d0ni39tl43kg">
                Start with the details that matter.
              </h1>
              <p className="mt-7 max-w-xl text-lg leading-8 text-stone-600" data-id="element-174" data-mp="3qh3cwfr4ww1r">
                A little context about your systems, people, and priorities
                makes the first reply much more useful. This form creates an
                email draft for you to review and send.
              </p>
            </div>
            <aside className="border border-[#9bc6b5] bg-[#eaf4ef] p-6 sm:p-7" aria-label="What to expect" data-id="element-175" data-mp="36sp4b3t80f9x">
              <ClipboardListIcon className="h-6 w-6 text-[#286151]" aria-hidden="true" data-id="element-176" data-mp="2xttvdjyskr2x" />
              <h2 className="mt-6 text-xl font-semibold tracking-tight text-[#172820]" style={{
              fontFamily: 'var(--font-display)'
            }} data-id="element-177" data-mp="31vfgttpe6doq">
                A considered first step
              </h2>
              <ul className="mt-4 space-y-3 text-sm leading-6 text-[#3e564b]" data-id="element-178" data-mp="3gszgcl3irgni">
                <li data-id="element-179" data-mp="3ktjargwpk65y">• Share the actual workflow—not a polished version.</li>
                <li data-id="element-180" data-mp="3krf1skjycgyt">• Flag any deadlines or constraints early.</li>
                <li data-id="element-181" data-mp="cceurefys93l">• You can skip the budget question if it is too soon.</li>
              </ul>
              <a href="mailto:hello@daanish.co" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#286151] underline decoration-[#9bc6b5] underline-offset-4 hover:text-[#172820]" data-id="element-182" data-mp="h69a65oje1wv">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="2bkn41siy8yx4" /> Prefer a
                simple email?
              </a>
            </aside>
          </motion.div>
        </div>
      </section>
      <section className="border-t border-stone-200 bg-white px-5 py-14 sm:px-8 sm:py-20 lg:px-10" data-id="element-184" data-mp="1iw98djfc2eoq">
        <div className="mx-auto max-w-3xl" data-id="element-185" data-mp="1dx63byzcs8gr">
          <DiscoveryForm data-id="element-186" data-mp="1dyfzujqk58la" />
        </div>
      </section>
    </main>;
}